import { createBrowserHistory } from "history";

export const history = createBrowserHistory();
export const AppUrl = `${window.location.protocol}//${window.location.hostname}${
    window.location.hostname === "localhost" ? ":8080" : ""
}`;
export const ImageUrl = `${window.location.protocol}//${window.location.hostname}${
    window.location.hostname === "localhost" ? ":8080" : ""
}/assets/img`;
